import actionTypes from 'constants/checkoutWizardConstants';

export function goToNextStep() {
  return (dispatch) => {
    dispatch({ type: actionTypes.GO_TO_NEXT_STEP });
  };
}

export function goToStep(step) {
  return (dispatch) => {
    if (step >= 1) {
      dispatch({ type: actionTypes.GO_TO_STEP, payload: step });
    } else {
      dispatch({ type: actionTypes.STEP_CHANGE_REJECTED });
    }
  };
}

export function goToPreviousStep() {
  return (dispatch, getState) => {
    if (getState().checkoutWizard.get('currentStep') > 1) {
      dispatch({ type: actionTypes.GO_TO_PREVIOUS_STEP });
    } else {
      dispatch({ type: actionTypes.STEP_CHANGE_REJECTED });
    }
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/checkoutWizardActions.js